export class Stack<T> {
  constructor(private readonly _max?: number) {
  }

  private _values: T[] = [];

  push(value: T): void {
    this._values.push(value);
    if (this.max < this._values.length) {
      this._values = this._values.slice(this._values.length - this.max);
    }
  }

  private get max(): number {
    return (this._max && (0 < this._max))
      ? this._max
      : this._values.length;
  }

  pop(): T {
    return (0 < this.count)
      ? this._values.pop()
      : null;
  }

  get count(): number {
    return this._values.length;
  }

  clear(): void {
    this._values = [];
  }
}
